import React, { useEffect, useState } from "react";
import loadConfig from "../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import {
  GetLisExpectedObjectivesForStageByStageId,
  UpdateExpectedObjectivesForStageByStageId,
} from "../../Redux/Reducers/ReportStage/ExpectedObjectivesForStag";
import InputAHSF from "../../Components/InputAHSF";
import { ValidationAllPageReports } from "../../Redux/Reducers/ReportStage/ValidateReportStage";
import {
  GetAllPR_InformationSocialMediaByPR_ReportsStagesGuid,
  UpdatepR_InformationSocialMedia,
} from "../../Redux/Reducers/ReportStage/InformationSocialMedia";

const InformationSocialMediaPage = (props) => {
  const [jsonData, setJsonData] = useState();
  const [SocialMediaList, setSocialMediaList] = useState([]);
  const [Refresh, setRefresh] = useState(0);
  const [
    descriptionOfAchievementOfSubGoals,
    setDescriptionOfAchievementOfSubGoals,
  ] = useState("");
    const reportStageGuid=useSelector((state)=>state.Stages.reportStageGuid)
  
  const [achievementOfSubGoals, setAchievementOfSubGoals] = useState(0);
  const getJsonData = async () => {
    let jsonData = await loadConfig();
    setJsonData(jsonData);
  };

  useEffect(() => {
    getJsonData();
  }, []);

  const dispatch = useDispatch(); // Used to dispatch Redux actions.
  const state = useSelector((state) => {
    return {
      loadingLisExpectedObjectivesForStage:
        state.ExpectedObjectivesForStage.loadingLisExpectedObjectivesForStage,
      ValidateReportStage: state.ValidateReportStage.ValidateReportStage,
    };
  });

  const getData = async () => {
    let data = await dispatch(
      GetAllPR_InformationSocialMediaByPR_ReportsStagesGuid(
        {
          specificOrMulti: true,
          stageGuid: props.pR_ReportsStagesGuid,
          reportGuid: props.reportId,
          applicationInfoGuid: "string"
        }
      )
    );
    if (data?.payload.length) {
      setSocialMediaList(data?.payload);
    }
  };

  useEffect(() => {
    getData();
  }, [Refresh,reportStageGuid]);

  const UpdateSocialMedia = async (
    column,
    numberOfCurrentFollowers,
    numberOfPosts,
    viewsNumber
  ) => {
    const update = await dispatch(
      UpdatepR_InformationSocialMedia({
        pR_InformationSocialMediaId: column.pR_InformationSocialMediaId,
        numberOfCurrentFollowers:
          numberOfCurrentFollowers == "" ? null : numberOfCurrentFollowers,
        numberOfPosts: numberOfPosts == "" ? null : numberOfPosts,
        viewsNumber: viewsNumber == "" ? null : viewsNumber,
        pR_SocialMediaNameId: column.pR_SocialMediaNameId,
        pR_ReportsStagesGuid: column.pR_ReportsStagesGuid,
      })
    );
    if (update.payload == "success") {
      setDescriptionOfAchievementOfSubGoals("");
      setAchievementOfSubGoals(0);
      setRefresh(Refresh + 1);
    }
  };
  

  return (
    <>
      <div id="EvaluationInformationId" className="ContinerMarks-section">
        <p className="title">
          {jsonData?.InformationSocialMediaPlatforms?.nameAR}
        </p>
        <div className="ContinerTableYesNo">
          <table>
            <thead>
              <tr key="2">
                <th>{jsonData?.socialMediaSites?.nameAR}</th>
                <th>{jsonData?.NumberOfCurrentFollowers?.nameAR}</th>
                <th>{jsonData?.NumberOfPublicationsRelated?.nameAR}</th>
                <th>{jsonData?.NumberOfViews?.nameAR}</th>
              </tr>
            </thead>
            <tbody>
              {SocialMediaList &&
                SocialMediaList.map((elem, index) => {
                  return (
                    <>
                      <tr key={elem.pR_InformationSocialMediaId}>
                        <td>{elem.socialMediaName}</td>

                        <td>
                          <InputAHSF
                            fieldsName="yesNoTableDropDown"
                            type="number"
                            show={true}
                            hidelable={true}
                            disabled={!props.canEdit}
                            className="form_control_input"
                            defaultValue={elem.numberOfCurrentFollowers}
                            style={{ width: "100%" }}
                            onChange={async (e) => {
                              await UpdateSocialMedia(
                                elem,
                                e.target.value,
                                elem.numberOfPosts,
                                elem.viewsNumber
                              );
                            }}
                            onBlur={async (e) => {
                              await UpdateSocialMedia(
                                elem,
                                e.target.value,
                                elem.numberOfPosts,
                                elem.viewsNumber
                              );
                            }}
                            showValidationMessage={
                              state.ValidateReportStage
                                ? state.ValidateReportStage.includes(
                                    `NumberOfCurrentFollowers` +
                                      elem.pR_InformationSocialMediaId
                                  )
                                : false
                            }
                            validationMessage="حقل اجباري"
                          />
                        </td>

                        <td>
                          <InputAHSF
                            fieldsName="yesNoTableDropDown"
                            show={true}
                            hidelable={true}
                            style={{ width: "100%" }}
                            className={`form_control_input `}
                            type="number"
                            disabled={!props.canEdit}
                            defaultValue={elem.numberOfPosts}
                            onChange={async (e) => {
                              await UpdateSocialMedia(
                                elem,
                                elem.numberOfCurrentFollowers,
                                e.target.value,
                                elem.viewsNumber
                              );
                            }}
                            onBlur={async (e) => {
                              await UpdateSocialMedia(
                                elem,
                                elem.numberOfCurrentFollowers,
                                e.target.value,
                                elem.viewsNumber
                              );
                            }}
                            showValidationMessage={
                              state.ValidateReportStage
                                ? state.ValidateReportStage.includes(
                                    `NumberOfPosts` +
                                      elem.pR_InformationSocialMediaId
                                  )
                                : false
                            }
                            validationMessage="حقل اجباري"
                          />
                        </td>
                        <td>
                          <InputAHSF
                            fieldsName="yesNoTableDropDown"
                            show={true}
                            hidelable={true}
                            style={{ width: "100%" }}
                            className={`form_control_input `}
                            type="number"
                            disabled={!props.canEdit}
                            defaultValue={elem.viewsNumber}
                            onChange={async (e) => {
                              await UpdateSocialMedia(
                                elem,
                                elem.numberOfCurrentFollowers,
                                elem.numberOfPosts,
                                e.target.value
                              );
                            }}
                            onBlur={async (e) => {
                              await UpdateSocialMedia(
                                elem,
                                elem.numberOfCurrentFollowers,
                                elem.numberOfPosts,
                                e.target.value
                              );
                            }}
                            showValidationMessage={
                              state.ValidateReportStage
                                ? state.ValidateReportStage.includes(
                                    `ViewsNumber` +
                                      elem.pR_InformationSocialMediaId
                                  )
                                : false
                            }
                            validationMessage="حقل اجباري"
                          />
                        </td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default InformationSocialMediaPage;
